import type { EpgInfo, TvChannel } from '@setplex/tria-api'
import type { CurrentTvMediaUrlWithEpg } from '~/shared/interfaces'
import type { IWithRewoundMediaUrl } from '~/shared/interfaces/mediaUrl'

import { ScheduleType } from '@setplex/tria-api'
import { endOfHour, formatISO, getUnixTime, subHours } from 'date-fns'
import { inRange, NO_EPG_ID } from '~/entities/epg/programs'

const MAX_REWIND_BACK_HOURS = 2

export const mergeUrlAndEpgSyncedInfo = ({
  mediaUrlData,
  program,
  channel,
}: {
  mediaUrlData: IWithRewoundMediaUrl
  channel: TvChannel
  program: EpgInfo
}): CurrentTvMediaUrlWithEpg => {
  const rewindLengthSec = mediaUrlData.liveRewindOptions?.rewindLengthSec

  const hasEpg = Boolean(program.title)

  const rewindLengthH = rewindLengthSec
    ? rewindLengthSec / 3600
    : MAX_REWIND_BACK_HOURS

  const fakeStartTime = subHours(new Date(), rewindLengthH)

  const fakeEndTime = formatISO(endOfHour(new Date())).toString()

  const startTime = getUnixTime(hasEpg ? program.actualStartMs : fakeStartTime)
  const endTime = getUnixTime(hasEpg ? program.actualStopMs : fakeEndTime)

  return {
    ...mediaUrlData,
    programTitle: program.name ?? '',
    scheduleType: hasEpg ? ScheduleType.EPG : ScheduleType.HOURLY,
    startTime,
    endTime,
    channelId: channel.id,
  }
}

export const getProgramByStamp = ({
  channel,
  programs,
  stamp,
}: {
  channel: TvChannel | null
  programs: Map<string, EpgInfo[]>
  stamp: number
}) => {
  if (channel == null) return null

  const epg = programs.get(channel.epgId ?? NO_EPG_ID)
  if (epg == null) return null

  const isLive = inRange(stamp)
  const program = epg.find((p) => isLive([p.actualStartMs, p.actualStopMs]))
  if (program == null) return null

  return program
}
